<section class="general-section">
  <header class="header-bg">
    <div class="header-content">
      <h1 class="welcome-message">{{welcomeMessage}}, {{userName}}!</h1>
      <div class="access-info">
        <p class="access-time">Acceso actual: {{actuallyDate}}</p>
      </div>
    </div>
    <div class="divider">
      <div class="divider-line"></div>
    </div>
    <div class="user-actions" routerLink="/pages/">
      <img src="../../../assets/logo-iris.png" alt="Logo Iris" class="logo" />
      <button class="logout-button" (click)="logout()">Salir</button>
    </div>
  </header>

  <nav class="nav-bar">
    <div class="nav-item" routerLink="/pages/get-addons" *ngIf="hasRole('cx') || hasRole('admin')">
      <div class="nav-divider"></div>
      <div class="nav-content">
        <div class="nav-icon">
          <img src="../../../../assets/iconsConsultUsers.png" alt="User consultation icon" />
        </div>
        <span class="nav-label">Consultar Complemento</span>
        <div class="nav-divider-horizontal" [ngClass]="{ 'nav-item-active': activeTab === 'get-addons'}"></div>
      </div>

    </div>
    <div class="nav-item" routerLink="/pages/get-user" *ngIf="hasRole('cx') || hasRole('admin')">
      <div class="nav-divider"></div>
      <div class="nav-content">
        <div class="nav-icon">
          <img src="../../../../assets/iconsRoles.png" alt="Rols icon" />
        </div>
        <span class="nav-label">Consultar Usuario</span>
        <div class="nav-divider-horizontal" [ngClass]="{ 'nav-item-active-roles': activeTab === 'get-user'}"></div>
      </div>
    </div>
    <div class="nav-item" routerLink="/pages/unblock-user" *ngIf="hasRole('cx') || hasRole('admin')">
      <div class="nav-divider"></div>
      <div class="nav-content">
        <div class="nav-icon">
          <img src="../../../../assets/iconsUnlock.png" alt="Unlock icon" />
        </div>
        <span class="nav-label nav-label-margin">Desbloquear</span>
        <div class="nav-divider-horizontal" [ngClass]="{ 'nav-item-active': activeTab === 'unblock-user'}"></div>
      </div>
    </div>
    <div class="nav-item" routerLink="/pages/update-contact" *ngIf="hasRole('cx') || hasRole('admin')">
      <div class="nav-divider"></div>
      <div class="nav-content">
        <img src="../../../../assets/iconUpdateUser.png" alt="Update contact icon" class="nav-icon" />
        <span class="nav-label">Actualizar contacto</span>
        <div class="nav-divider-horizontal" [ngClass]="{ 'nav-item-active': activeTab === 'update-contact'}"></div>
      </div>
    </div>
    <div class="nav-item" routerLink="/pages/crc-consult"
      *ngIf="hasRole('analytic') || hasRole('admin') || hasRole('cx')">
      <div class="nav-divider"></div>
      <div class="nav-content">
        <img src="../../../../assets/iconsCrc.png" alt="Update contact icon" class="nav-icon" />
        <span class="nav-label">Ley dejen de joder</span>
        <div class="nav-divider-horizontal" [ngClass]="{ 'nav-item-active': activeTab === 'crc-consult'}"></div>
      </div>
    </div>
    <div class="nav-item" routerLink="/pages/suppressed-email"
      *ngIf="hasRole('cx') || hasRole('admin') || hasRole('dev')">
      <div class="nav-divider"></div>
      <div class="nav-content">
        <img src="../../../../assets/iconsSuppressed.png" alt="Update contact icon" class="nav-icon" />
        <span class="nav-label">Lista de supresion SES</span>
        <div class="nav-divider-horizontal" [ngClass]="{ 'nav-item-active': activeTab === 'suppressed-email'}"></div>
      </div>
    </div>
    <div class="nav-item" routerLink="/pages/create-user" *ngIf="hasRole('admin')">
      <div class="nav-divider"></div>
      <div class="nav-content">
        <img src="../../../../assets/iconCreateUser.png" alt="Role assignment icon" class="nav-icon" />
        <span class="nav-label">Asignar Roles</span>
        <div class="nav-divider-horizontal" [ngClass]="{ 'nav-item-active': activeTab === 'create-user'}"></div>
      </div>
    </div>
    <!-- <div class="nav-item" routerLink="/pages/get-otp" *ngIf="userRol === 'admin' || userRol === 'cx'" >
      <div class="nav-divider"></div>
      <div class="nav-content">
        <img src="../../../../assets/iconOtp.png" alt="Update contact icon" class="nav-icon" />
        <span class="nav-label">Obtener Otp</span>
        <div class="nav-divider-horizontal" [ngClass]="{ 'nav-item-active': activeTab === 'get-otp'}"></div>
      </div>
    </div> -->
    <div class="nav-item" routerLink="/pages/first-login" *ngIf="hasRole('admin') || hasRole('cx')">
      <div class="nav-divider"></div>
      <div class="nav-content">
        <img src="../../../../assets/iconFirstLogin.png" alt="Update contact icon" class="nav-icon" />
        <span class="nav-label">Obtener Url</span>
        <div class="nav-divider-horizontal" [ngClass]="{ 'nav-item-active': activeTab === 'first-login'}"></div>
      </div>
    </div>
    <div class="nav-item" routerLink="/pages/certificados" *ngIf="hasRole('cx') || hasRole('admin')">
      <div class="nav-divider"></div>
      <div class="nav-content">
        <img src="../../../../assets/iconCertificates.png" alt="Certificados icon" class="nav-icon" />
        <span class="nav-label">Certificados</span>
        <div class="nav-divider-horizontal" [ngClass]="{ 'nav-item-active': activeTab === 'certificados'}"></div>
      </div>
    </div>
    <div class="nav-item" routerLink="/pages/infraestructura-seguimiento"
      *ngIf="hasRole('admin') || hasRole('infraestructura')">
      <div class="nav-divider"></div>
      <div class="nav-content">
        <img src="../../../../assets/iconSeguimientoInfra.png" alt="Infrastructure tracking icon" class="nav-icon" />
        <span class="nav-label">Seguimiento Infraestructura</span>
        <div class="nav-divider-horizontal"
          [ngClass]="{ 'nav-item-active': activeTab === 'infraestructura-seguimiento'}"></div>
      </div>
    </div>
    <div class="nav-item" routerLink="/pages/chat-boris"
      *ngIf="hasRole('comercial') || hasRole('admin') || hasRole('cdt')">
      <div class="nav-divider"></div>
      <div class="nav-content">
        <img src="../../../../assets/iconChatDocumentVinculation.png" alt="Chat icon" class="nav-icon" />
        <span class="nav-label">Asistente Boris</span>
        <div class="nav-divider-horizontal" [ngClass]="{ 'nav-item-active': activeTab === 'chat-boris'}"></div>
      </div>
    </div>
    <div class="nav-item" routerLink="/pages/inventario" *ngIf="hasRole('infraestructura') || hasRole('admin')">
      <div class="nav-divider"></div>
      <div class="nav-content">
        <div class="nav-icon" aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <path d="M3 7.5 12 3l9 4.5-9 4.5L3 7.5z"></path>
            <path d="M3 7.5V17l9 4.5 9-4.5V7.5"></path>
            <path d="M12 12v9"></path>
          </svg>
        </div>
        <span class="nav-label">Inventario</span>
        <div class="nav-divider-horizontal" [ngClass]="{ 'nav-item-active': activeTab === 'inventario'}"></div>
      </div>
    </div>
    <div class="nav-item" routerLink="/pages/vinculador-pagador-pm" *ngIf="hasRole('admin') || hasRole('comercial')">
      <div class="nav-divider"></div>
      <div class="nav-content">
        <img src="../../../../assets/iconVinculo.png" alt="Document upload icon" class="nav-icon" />
        <span class="nav-label">Vinculador Pagador PM</span>
        <div class="nav-divider-horizontal" [ngClass]="{ 'nav-item-active': activeTab === 'vinculador-pagador-pm'}">
        </div>
      </div>
    </div>
  </nav>

  <div class="container">
    <router-outlet />
  </div>
  <app-footer [ip]="ip"></app-footer>
</section>